import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Products from "../pages/products/page";
import Gallery from "../pages/gallery/page";
import Testimonials from "../pages/testimonials/page";
import Contact from "../pages/contact/page";
import BifoldDoors from "../pages/bifold-doors/page";
import RoofLanterns from "../pages/roof-lanterns/page";
import CompositeDoors from "../pages/composite-doors/page";
import Conservatories from "../pages/conservatories/page";
import Windows from "../pages/windows/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-conditions/page";
import CancellationPolicy from "../pages/cancellation-policy/page";
import CookiesPage from "../pages/cookies/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/products", element: <Products /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/contact", element: <Contact /> },
  { path: "/bifold-doors", element: <BifoldDoors /> },
  { path: "/roof-lanterns", element: <RoofLanterns /> },
  { path: "/composite-doors", element: <CompositeDoors /> },
  { path: "/conservatories", element: <Conservatories /> },
  { path: "/windows", element: <Windows /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-conditions", element: <TermsConditions /> },
  { path: "/cancellation-policy", element: <CancellationPolicy /> },
  { path: "/cookies", element: <CookiesPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
